module.exports = __webpack_public_path__ + "assets/logo_footer.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/logo_footer.svg
 ** module id = 220
 ** module chunks = 1
 **/